import React from 'react';
import TableFilters from "../TableFilters";
import DataTable from '../DataTable';

const DataTableWithFiltersView = ({
                                    search,
                                    data = [],
                                    options,
                                    customClassNames = {},
                                    columns,
                                    totalPages,
                                    totalResults,
                                    allowSearchByCustomerName,
                                    allowSearchByShumaID,
                                    preparedDataForExcel,
                                    headersForExcel,
                                    excelFileName,
                                    module,
                                    getListForExcel,
                                    ...rest
                                  }) => {

  return (
    <div>
      <TableFilters
        module={module}
        search={search}
        options={options}
        allowSearchByCustomerName={allowSearchByCustomerName}
        allowSearchByShumaID={allowSearchByShumaID}
        preparedDataForExcel={preparedDataForExcel}
        headersForExcel={headersForExcel}
        excelFileName={excelFileName}
        customClassNames={customClassNames}
        getListForExcel={getListForExcel}
        {...rest}
      />
      <DataTable
        data={data}
        columnsList={columns}
        customClassNames={customClassNames}
        totalPages={totalPages}
        totalResultCount={totalResults}
        {...rest}
      />
    </div>
  )
};

export default DataTableWithFiltersView;